import dynamic from "next/dynamic";
import { FieldValues } from "react-hook-form";

import { OutlinedTextFieldWysiwygProps } from "./type";

export const OutlinedTextFieldWysiwyg = dynamic(
  () =>
    import("./OutlinedTextFieldWysiwygSsr").then((mod) => {
      const Component = <T extends FieldValues>(props: OutlinedTextFieldWysiwygProps<T>) => {
        return <mod.OutlinedTextFieldWysiwygSsr {...props} />;
      };
      Component.displayName = "OutlinedTextFieldWysiwyg";
      return Component;
    }),
  { ssr: false }
) as <T extends FieldValues>(props: OutlinedTextFieldWysiwygProps<T>) => React.ReactElement;
